import { render } from "./CollectionReport.vue?vue&type=template&id=74d9d340"
import script from "./CollectionReport.vue?vue&type=script&lang=js"
export * from "./CollectionReport.vue?vue&type=script&lang=js"

import "./CollectionReport.vue?vue&type=style&index=0&id=74d9d340&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__